import { GraphQLQuery } from "./graphql.js";
import { queries } from "./queries/index.js";
// import type { ArweaveBlock, ArweaveBlockVars } from "./queries/arweave/block.js";
// import type { ArweaveTransaction, ArweaveTransactionVars } from "./queries/arweave/transaction.js";
export class Query {
    opts;
    constructor(opts = { url: new URL("https://node1.irys.xyz/graphql") }) {
        if (!opts.url)
            throw new Error("URL is required");
        opts.url = new URL(opts.url);
        this.opts = opts;
    }
    search(queryName, opts) {
        // const queryInstance =
        const query = opts?.query ?? queries[queryName];
        const queryInstance = new GraphQLQuery({ ...this.opts, query, queryName });
        // @ts-expect-error overloading
        return queryInstance;
    }
}
export default Query;
//# sourceMappingURL=query.js.map